import React from "react";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { withStyledInputLabel } from "./StyledFormInputHoc.js";
const StyledToggleComponent = (props) => {
  const { options, value, onChange, disabled } = props;
  const handleChange = (_event, newValue) => {
    if (newValue !== null && newValue !== void 0) {
      onChange(options.find((o) => o.value === newValue).value);
    }
  };
  return /* @__PURE__ */ React.createElement(ToggleButtonGroup, { value, exclusive: true, onChange: handleChange, disabled }, options.map((o) => /* @__PURE__ */ React.createElement(ToggleButton, { key: o.value, value: o.value, disabled: o.disabled, selected: o.value === value }, /* @__PURE__ */ React.createElement(LocalizedText, { label: o.label }))));
};
const StyledToggle = withStyledInputLabel(StyledToggleComponent);
export {
  StyledToggle
};
//# sourceMappingURL=StyledToggle.js.map
